module.exports = __webpack_public_path__ + "img/invest_block2.fbc42eca.png";